import {fetchBaseQuery} from '@reduxjs/toolkit/query/react';
import GlobalConst from "../../src/constants/GlobalConst";
import Cookies from "js-cookie";

export const createBaseQuery = (baseAPIURL) => {
    return fetchBaseQuery({
        baseUrl: baseAPIURL || GlobalConst.API.FULLURL,
        prepareHeaders: (headers, {getState}) => {
            const tfsessionJwt = Cookies.get('tfsession')
            if (tfsessionJwt) {
                headers.set('Authorization', `Bearer ${tfsessionJwt}`);
            }
            headers.set('Content-Type', 'application/json');
            return headers;
        },
    });
};